export default [
  {
    path: "/onboarding-new-company",
    name: "onboarding-new-company",
    component: () => import("./OnboardingNewCompany.vue"),
  },
  {
    path: "/payment-complete",
    name: "payment-complete",
    component: () => import("./PaymentComplete.vue"),
  },
  {
    path: "/cancel-onboarding",
    name: "cancel-onboarding",
    component: () => import("./CancelOnboarding.vue"),
  },
];
